import React from 'react';
import { useSelector } from 'store';

function LoadingCursor() {
    const { isShow } = useSelector((state) => state.loadingCursor);
    return (
        <React.Fragment>
            {/* {isShow && ( */}
                <div className={`load-waiting ${isShow ? 'active': ''}`}>
                    <div className="content-loading">
                        <div className="load-waiting-logo">
                            <img src="/assistant-biger.jpg" alt="assistant.png" />
                        </div>
                        <div className="load-waiting-text">
                            <div className="text">
                                Loading...
                            </div>
                            <div className="child">
                                <div className="wave" />
                                <div className="wave" />
                                <div className="wave" />
                                <div className="wave" />
                                <div className="wave" />
                                <div className="wave" />
                                <div className="wave" />
                                <div className="wave" />
                                <div className="wave" />
                                <div className="wave" />
                            </div>
                        </div>
                    </div>
                </div>
            {/* )} */}
        </React.Fragment>
    );
}

export default LoadingCursor;
